import React from "react";
import { Alert, Button, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { ChevronRight } from "lucide-react";
import useProductRestrictions from "../../../shared/hooks/useProductRestrictions";
import { openSupportChat } from "../../../shared/utils/openSupportChat";

/**
 * Creates a note about launch only allowing log search going back 3 days for non-admins.
 */
const LogSearchUpgradeBanner = () => {
  const { productRestrictions } = useProductRestrictions();
  const log_retention_days = productRestrictions ? productRestrictions.log_retention_days : 3;

  return (
    <Alert
      color="gray"
      className="mb-9"
      buttons={
        <Button
          variant={ButtonVariant.TertiaryWhite}
          size="sm"
          rightIcon={<ChevronRight size={12} />}
          onClick={openSupportChat}
        >
          Speak to our team
        </Button>
      }
    >
      <span>
        Your <strong>Launch</strong> plan only allows you to search logs going back{" "}
        {log_retention_days} days. To search logs older than {log_retention_days} days, upgrade to
        our <strong>Professional</strong> or <strong>Enterprise</strong> plans.
      </span>
    </Alert>
  );
};

export default LogSearchUpgradeBanner;
